export default {
  data() {
    return {
      changeLateralityModal: false,
    }
  },
  methods: {
    onLocationClick() {
      if (this.wound && this.wound.followup_treatment && this.wound.location && this.wound.location.location_text) {
        this.changeLateralityModal = true
      } else {
        this.locationModal = true
      }
    },

    /**
     * @param {string} updatedText - The updated location text with new laterality
     */
    onChangeLateralitySave(updatedText) {
      if (!this.wound) return
      // apply the updated location text to the wound location
      this.wound.location = this.wound.location || {}
      this.wound.location.location_text = updatedText
      this.changeLateralityModal = false
    },
  },
}
